export const stopPropagation =
	(fn: () => void) => (event: React.MouseEvent<any, MouseEvent>) => {
		event.stopPropagation();
		return fn();
	};
